module.exports = __webpack_public_path__ + "afd91a3a4500b333310333083e5f833a.svg";